

// let's get this party started
document.addEventListener('DOMContentLoaded', function () {



  document.querySelectorAll('.js_burger_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      const burger = document.querySelector('.js_burger.m-active');
      if (burger) burger.click();
    });
  });



  // INPUT STATUS
  function checkFill(item) {
    item.value.length
      ? item.classList.add('m-filled')
      : item.classList.remove('m-filled');
  }


  document.querySelectorAll('.js_checkfill').forEach(item => {
    checkFill(item)
    item.onfocus = function () {
      item.classList.add('m-focused');
    }
    item.onblur = function () {
      item.classList.remove('m-focused');
      checkFill(item)
    }
    item.onkeyup = function () {
      checkFill(item)
    }
  });


  // ========================

  // INPUT CLEAR
  document.querySelectorAll('.js_input_clear').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      const targetInputs = item.parentNode.querySelectorAll('input, textarea');
      targetInputs.forEach(input => {
        input.value = '';
        input.classList.remove('m-filled');
        input.focus();
      });
    });
  });

  // ========================


  // SCROLL TO
  const scroller = new SweetScroll(
    {
      /* some options */
      trigger: '[data-scroll]',       // Selector for trigger (must be a valid css selector)
      header: '[data-scroll-header]', // Selector or Element for fixed header (Selector of must be a valid css selector)
      // header: '#header',
      duration: 1000,                 // Specifies animation duration in integer
      easing: 'easeInOutSine',         // Specifies the pattern of easing
      offset: 0,                      // Specifies the value to offset the scroll position in pixels
      vertical: true,                 // Enable the vertical scroll
      horizontal: false,              // Enable the horizontal scroll
      cancellable: true,              // When fired wheel or touchstart events to stop scrolling
      updateURL: false,               // Update the URL hash on after scroll (true | false | 'push' | 'replace')
      preventDefault: true,           // Cancels the container element click event
      stopPropagation: true,          // Prevents further propagation of the container element click event in the bubbling phase

      // Callbacks
      // before: null,
      after: (offset, $trigger, scroller) => {
        // move focus to target
        let targetItem;
        if (!$trigger && offset.top === 0) {
          targetItem = document.body;
        } else if ($trigger && $trigger.getAttribute('href')) {
          targetItem = document.querySelector($trigger.getAttribute('href'));
        } else if ($trigger && $trigger.getAttribute('data-scroll').substring(0, 1) === '#') {
          targetItem = document.querySelector($trigger.getAttribute('data-scroll'));
        }
        if (targetItem) {
          targetItem.focus();
          if (targetItem !== document.activeElement) {
            targetItem.setAttribute('tabindex', '-1');
            targetItem.focus();
            targetItem.blur();
            targetItem.removeAttribute('tabindex');
          }
        }
      },

    },
  );


  document.querySelectorAll('[data-scroll-top]').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      scroller.toTop(0);
    });
  });
  //===============================



  // ACTIVE TOGGLE
  let toggleHold = false;
  document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!toggleHold) {
        toggleHold = true;
        let toggleTarget = ''
        if (trigger.getAttribute('data-target')) {
          toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
        } else if (trigger.getAttribute('href')) {
          toggleTarget = document.querySelector(trigger.getAttribute('href'))
        } else {
          toggleTarget = trigger.closest('.js_toggle');
        }
        trigger.classList.toggle('m-active');
        toggleTarget.classList.toggle('m-active');

        setTimeout(() => {
          toggleHold = false;
        }, 500);
      }
    });
  });
  // ========================




});


// =================================================
// =================================================
// =================================================

